module.exports = __webpack_public_path__ + "img/course03.bb13e87e.png";